import { BADGE_LEVELS } from '../../services/badging/constants';

export const sortBadgesByLevelDesc = (badges) => {
  badges.sort((a, b) => {
    const badgeLevelIndexA = BADGE_LEVELS.findIndex((x) => x === a.rewardLevelId);
    const badgeLevelIndexB = BADGE_LEVELS.findIndex((x) => x === b.rewardLevelId);
    return badgeLevelIndexB - badgeLevelIndexA;
  });
  return badges;
};
